import { useOptionalCommunity } from './CommunityContext'
import { parseNavigation, type HideableNative, type NavLayout, type ThemeNavigation } from './theme'

/**
 * F-191 phase 5: how the community's navigation looks, from the active theme
 * (`community.appearance.navigation`, copied there on activation).
 * - `layout`: the side menu (today) or the bar on top (sections in the header
 *   from 1024 px, a strip of section pills below it on phones);
 * - `hiddenNative`: the native shortcuts the community hides for everyone,
 *   the team included (§4.5.1). The pages stay reachable by their URL and
 *   nothing leaves Settings or Administration.
 */
export const communityNavigation = (appearance: unknown): ThemeNavigation =>
  parseNavigation(appearance && typeof appearance === 'object' ? (appearance as { navigation?: unknown }).navigation : null)

/** The community's navigation block (today's defaults for an older API or a missing key). */
export function useCommunityNavigation(): ThemeNavigation {
  const community = useOptionalCommunity()
  return communityNavigation(community?.appearance)
}

/** The layout the community picked: `sidebar` (default) or `top`. */
export const useNavLayout = (): NavLayout => useCommunityNavigation().layout

/** Whether the community hides this native element (for everyone, the team included). */
export const useNativeHidden = (key: HideableNative): boolean => useCommunityNavigation().hiddenNative.includes(key)
